
export interface IEnsurePetAlertsRequest {
    petId: number;
    PetAlertIds: number[];
}

export class EnsurePetAlertsRequest implements IEnsurePetAlertsRequest {
    petId: number;
    PetAlertIds: number[] = [];

    constructor(params: Partial<EnsurePetAlertsRequest> = {}) {
        const {
            petId = 0,
            PetAlertIds = [] as Array<number>
        } = params;

        this.petId = petId;
        this.PetAlertIds = PetAlertIds;
    }
}
